module.exports = __webpack_public_path__ + "static/media/time.8457e274.svg";